<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>
		<Content class="app-content__main">
			<h1>{{appName}}</h1>
			<TableFuncs>
				<Button type="primary" icon="ios-add-circle-outline" @click="addShow">新增版本</Button>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="guanli">
					<Button type="success" size="small" style="margin-right: 5px" @click="versionCheck(row)">版本审核</Button>
				</template>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
					<Button type="error" size="small" style="margin-right: 5px" @click="delData(row.id)">删除</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addStoreShow" :title="addForm.id?'编辑版本':'新增版本'">
			<Form ref="addForm" :model="addForm" :label-width="120" :rules="addRule">
				<FormItem label="版本名称" prop="name">
					<Input v-model="addForm.name" placeholder="请输入版本名称"></Input>
				</FormItem>
				<FormItem label="版本号" prop="version">
					<Input v-model="addForm.version" type="number" placeholder="请输入版本号"></Input>
				</FormItem>
				<FormItem label="系统类型" prop="sysType">
					<RadioGroup v-model="addForm.sysType">
						<Radio label="andriod"></Radio>
						<Radio label="ios"></Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="版本内容" prop="content">
					<Input v-model="addForm.content" placeholder="请输入版本内容" type="textarea"
						:autosize="{minRows: 2,maxRows: 5}"></Input>
				</FormItem>
				<FormItem label="apk文件" prop="url">
					<Upload :action="uploadFile" name="file" :on-success="uploadCallback" :default-file-list="fileList"
						:data="uploadData" :format="['apk','jpg']" :on-format-error="fileFormatError">
						<Button icon="ios-cloud-upload-outline">上传文件</Button>
					</Upload>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrUpdateData">确认提交</Button>
			</div>
		</Modal>
		
		<Modal v-model="versionCheckShow" :title="checkVersionData.name+'版本审核'">
			<Form :label-width="120">
				<FormItem v-for="(item,index) in appStores" :key="item.id" :label="item.storeName">
					<i-switch v-model="item.checkState==1" size="large" @on-change="changeStoreStatus($event,item)">
						<span slot="open">已审核</span>
						<span slot="close">未审核</span>
					</i-switch>
				</FormItem>				
			</Form>
			<div slot="footer">
			</div>
		</Modal>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition'
	import TableFuncs from '../../components/statistics/TableFuncs'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				uploadFile: api.statistics.uploadFile,
				uploadData: { filePath: 'apk' },
				fileList: [],
				appName: this.$route.query.appName,
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				addStoreShow: false,
				addForm: {
					name: '',
					version: '',
					sysType: 'andriod',
					content: '',
					url: ''
				},
				addRule: {
					name: [
						{ required: true, message: '请输入版本名称', trigger: 'blur' }
					],
					version: [
						{ required: true, message: '请输入版本号', trigger: 'blur' },
					],
					sysType: [
						{ required: true, message: '请选择系统类型', trigger: 'blur' }
					],
					url: [
						{ required: true, message: '请上传apk文件', trigger: 'blur' }
					],
				},
				versionCheckShow:false,
				checkVersionData:{},
				appStores:[],
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '版本名称',
						key: 'name',
						width: 100,
						align: 'center'
					},
					{
						title: '版本号',
						key: 'version',
						width: 100,
						align: 'center'
					},
					{
						title: '系统类型',
						key: 'sysType',
						width: 100,
						align: 'center',
						render: (h, params) => {
							return h('span', params.row.sysType == 1 ? 'andriod' : 'ios');
						}
					},
					{
						title: '版本内容',
						key: 'content',
						align: 'center'
					},
					{
						title: '下载链接',
						key: 'url',
					}, {
						title: '创建日期',
						key: 'createTime',
						width: 180,
						align: 'center'
					},
					{
						title: '版本管理',
						slot: 'guanli',
						width: 200,
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						width: 200,
						align: 'center'
					}

				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			refreshData() {
				this.pageNum = 1,
					this.queryData = []
				this.getData()
			},
			getData() {
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					appId: this.$route.query.id
				}
				api.statistics
					.getAppVersion(queryParams)
					.then(res => {
						const result = res.data || {}
						this.totalRecord = result.totalRecordNum || 0
						this.queryData = result.records
					})
					.catch(err => {
						this.$Message.error('获取数据列表失败: ' + err.message)
					})
					.then(() => {
						this.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			addOrUpdateData() {
				const that = this
				that.$refs['addForm'].validate((valid) => {
					if (valid) {
						let params = { ...that.addForm }
						params.sysType = params.sysType == 'andriod' ? 1 : 2
						params.appId = this.$route.query.id
						params.version = parseInt(params.version)
						api.statistics
							.addOrEditVersion(params)
							.then(res => {
								that.$Message.success('Success!');
								if (that.addForm.id) {
									//编辑
									that.queryData.forEach(item => {
										if (item.id == that.addForm.id) {
											item.name = params.name
											item.version = params.version
											item.sysType = params.sysType
											item.content = params.content
											item.url = params.url
										}
									})
								} else {
									//新增
									that.refreshData()
								}
								that.addStoreShow = false
							})
							.catch(err => {
								that.$Message.error('新增失败: ' + err.message)
							})

					}
				})
			},
			delData(id) {
				const that = this
				that.$Modal.confirm({
					title: '操作确认',
					content: '数据删除不可恢复，确定删除吗？',
					onOk: function() {
						api.statistics
							.delVersion({ 'id': id })
							.then(res => {
								that.$Message.success('Success!');
								that.refreshData()
							})
					}
				})

			},
			addShow() {
				this.addForm = {
					name: '',
					version: '',
					sysType: 'andriod',
					content: '',
					url: ''
				}
				this.fileList = []
				this.addStoreShow = true
			},
			editData(rowData) {
				this.addForm = {
					id: rowData.id,
					name: rowData.name,
					version: rowData.version,
					sysType: rowData.sysType == 1 ? 'andriod' : 'ios',
					content: rowData.content,
					url: rowData.url
				}
				this.fileList = [{
					name: rowData.url,
					url: rowData.url
				}]
				this.addStoreShow = true

			},
			uploadCallback(response, file, fileList) {
				this.addForm.url = response.data.url
				this.fileList = [{
					name: response.data.fileName,
					url: response.data.url
				}]
			},
			fileFormatError(file, fileList) {
				this.$Notice.warning({
					title: '文件格式错误',
					desc: 'File format of ' + file.name + ' is incorrect, please select apk'
				});
			},
			versionCheck(data){
				let that=this
				that.checkVersionData=data,
				api.statistics
					.getVersionAllStore({ 'id': data.id })
					.then(res => {
						that.appStores=res.data
						that.versionCheckShow=true
					})
			},
			changeStoreStatus(state,data){
				api.statistics
					.storeVersionCheck({ 'storeVersionId': data.id,checkState:state?1:0 })
					.then(res => {
						that.$Message.success('Success!');
					})
			}
		},



	}
</script>
